module.exports = __webpack_public_path__ + "img/us.9ab3417.webp";